import React, {useEffect, useState} from "react"
import {connect} from "react-redux";
import PropTypes from "prop-types";

import {useIsMounted} from "../../../../misc/helperHooks";
import {getCurrentLayout} from "../../../appLayout";
import {getImagePromiseFromLayout} from "../../../../misc/getCanvasImageFromLayout";
import {baseNewImagesPath} from "../../../assets";
import MaterialSpinner from "../../../ui/materialSpinner";


const LeadCapturePopupBoxImage = (props) => {

  const {imageOnly, className, visualizersLoadedLength} = props;
  const isMounted = useIsMounted();

  const layout = getCurrentLayout();
  const [thumbnailUrl, setThumbnailUrl] = useState(
    layout.layoutThumbnails && layout.layoutThumbnails[layout.type] ? layout.layoutThumbnails[layout.type] : ""
  );

  useEffect(() => {
    if (!thumbnailUrl && visualizersLoadedLength) {
      const getLayoutThumbnail = async () => {
        const response = await getImagePromiseFromLayout(layout);
        if (isMounted()) {
          // console.log("response", response);
          setThumbnailUrl(response || `${baseNewImagesPath}images/image-not-found.png`);
        }
      }
      getLayoutThumbnail(isMounted);
    }
  }, [visualizersLoadedLength]); // eslint-disable-line react-hooks/exhaustive-deps

  if (!thumbnailUrl || !visualizersLoadedLength) {
    return <MaterialSpinner/>
  }

  if (imageOnly) {
    return <img src={thumbnailUrl} className={className || ""} alt="canvas image"/>
  }

  return <div className={className || ""} style={{backgroundImage: `url(${thumbnailUrl})`}} />
}

LeadCapturePopupBoxImage.propTypes = {
  imageOnly: PropTypes.bool,
  className: PropTypes.string,
}

const mapStateToProps = (store) => {
  const {visualizersLoaded} = store.serverState;
  return {
    visualizersLoadedLength: visualizersLoaded.length,
  };
};

export default connect(mapStateToProps)(LeadCapturePopupBoxImage)

